
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/information",
      function () {
        return require("private-next-pages/information.js");
      }
    ]);
  